import { Component, OnInit, ViewChild } from "@angular/core";
import { firstValueFrom, Observable, Subscription, take } from "rxjs";
import { CatalogPaginationRequest } from "src/app/features/shared/models/CatalogPagination/CatalogPaginationRequest";
import { FilterRequest } from "src/app/features/shared/models/Filter/FilterRequest";
import { UsersCatalogKeys } from "../../models/UsersCatalogKeys";
import { UserService } from "../../services/Users.service";
import { environment } from "src/environments/environment";
import { GenericTableComponent } from "src/app/features/ui/organisms/generic-table/components/generic-table.component";

@Component({
  selector: "users-list",
  templateUrl: "./users-list.component.html",
  styleUrls: ["./users-list.component.css"],
})
export class UsersListComponent implements OnInit {
@ViewChild(GenericTableComponent) child;

  columnHeader : UsersCatalogKeys = {
    Id: { displayName: "Id", filterable: false, activeFilter: null },
    Customer_Description: { displayName: "Cliente", filterable: true, activeFilter: null } ,
    // UserName: { displayName: "Usuario", filterable: false, activeFilter: null } ,
    Email: { displayName: "Email", filterable: false, activeFilter: null } ,
    Rol: { displayName: "Roles", filterable: false, activeFilter: null } ,
    Status: { displayName: "Status", filterable: false, activeFilter: null } ,
    UserNameCitronella: { displayName: "Usuario Citronella", filterable: false, activeFilter: null } ,
    Actions: { displayName: "Acciones", filterable: false, activeFilter: null } 
  };

  catalogPaginationRequest: CatalogPaginationRequest = {
    page: 1,
    dato: "",
    getInactive: false,
    filters: []
  }

  hasInactives: boolean = true;
  hasEditables: boolean = true;
  hasDeletables: boolean = true;
  filtersRequest : FilterRequest[] = [];
  filterOptions: { [key: string]: string[] } = {};

  tableData$: Observable<any[]> = new Observable<any[]>();
  tableData: any[];
  controllerName: string;
  paginador: number;

  subscription_getData: Subscription;
  subscription_getDataCount: Subscription;
  subscription_getDataFileterValues: Subscription;

  constructor(public usercatalogService: UserService) {
    this.controllerName = "users"
  }

  ngOnInit() {
    this.EndSubscriptions();
    this.getFilters();
    this.getData();
  }

  ngOnDestroy(): void {
    this.EndSubscriptions();
  }

  EndSubscriptions(){
    if(this.subscription_getData)
      this.subscription_getData.unsubscribe();
    if(this.subscription_getDataCount)
      this.subscription_getDataCount.unsubscribe();
    if(this.subscription_getDataFileterValues)
      this.subscription_getDataFileterValues.unsubscribe();
  }

  getFilters(){
    var filterKeys = Object.keys(this.columnHeader).filter(key => this.columnHeader[key].filterable);
    this.filtersRequest = filterKeys.map(key => ({
      key: key,
      value: "" 
    }));
    this.subscription_getDataFileterValues = this.usercatalogService.getFilterValues(this.filtersRequest).subscribe({
      next: (data) => {
        filterKeys.forEach(column => {
          this.filterOptions[column] = data.result.find(x => x.key == column).values;
        });
        if(!environment.production) console.log("filterValues datos",data, this.filterOptions);
      },
      error: (error) => {
        // TODO marca para complete despues
        console.error('Error al obtener valores de filtro', error);
      }
    });
  }


  async getData(){
    const [getCount, getData] = await Promise.all([
          firstValueFrom(this.usercatalogService.getCount(this.catalogPaginationRequest).pipe(take(1))),
          firstValueFrom(this.usercatalogService.getPage(this.catalogPaginationRequest).pipe(take(1)))
        ]);

    if (getCount.isSuccess) {
      this.paginador = getCount.result[0];
    }

    if (getData.isSuccess) {
      this.tableData = getData.result;
      this.tableData.map(item => {
        item['IsEditable'] = this.hasEditables;
        item['IsDeletable'] = (item['status'] == 'Activo' && this.hasDeletables);
      });
      this.child.setData(this.tableData, this.paginador);
    }

        
    // this.subscription_getDataCount = this.usercatalogService.getCount(this.catalogPaginationRequest).subscribe(data=>{
    //   this.paginador = data.result[0];
    //   if(!environment.production) console.log("datos",this.paginador);
    // },(error)=>{

    // });
    // this.subscription_getData = this.usercatalogService.getPage(this.catalogPaginationRequest).subscribe(data=>{
    //   if(data.isSuccess==true)
    //   {
    //     // Apply condition on edit and delete button
    //   this.tableData = data.result;
    //   this.tableData.map(item => {
    //     item['IsEditable'] = this.hasEditables;
    //     item['IsDeletable'] = (item['status'] == 'Activo' && this.hasDeletables);
    //   // if (item['client'] === 'Geointelligent') {
    //   // }
    //   // return item;
    //   });
    //   this.child.setData(this.tableData, this.paginador);

    //   }
    // },(error)=>{

    // });
  }
}
